'use client';

type EnvVars = Record<string, string | undefined>;

interface AppEnvScriptProps {
  /**
   * Объект с переменными окружения, которые нужно передать на клиент.
   */
  env: EnvVars;
}

/**
 * Внедряет переменные окружения на клиентскую сторону через window.__ENV__.
 * Используется в корневом layout.tsx, чтобы сделать переменные доступными для
 * клиентских скриптов без необходимости использовать NEXT_PUBLIC_.
 * Это серверный компонент, который выполняется только на сервере.
 */
export const AppEnvScript = ({ env }: AppEnvScriptProps) => {
  const validEnv = Object.entries(env).reduce(
    (acc, [key, value]) => {
      if (value) {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, string>
  );

  if (Object.keys(validEnv).length === 0) {
    return null;
  }

  // Скрипт выполняется 1 раз, поэтому скрыл тег
  // Сделал установку __ENV__ в теле компонента
  // const script = `window.__ENV__ = ${JSON.stringify(validEnv)};`;

  if (typeof window !== 'undefined' && window.__ENV__ === undefined) {
    window.__ENV__ = validEnv;
  }

  return null;
};
